// extracted by mini-css-extract-plugin
export default {"selectCustom":"modalApproveDO_selectCustom__Fk772","selectInfo":"modalApproveDO_selectInfo__JtBJN","errorMessage":"modalApproveDO_errorMessage__Bz30S"};